module.exports = __webpack_public_path__ + "img/Willowbrook Station Concepts_Page_2.7ff265d6.jpg";